import script from "./NumberedAppSupportSection.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberedAppSupportSection.vue?vue&type=script&setup=true&lang=js"

import "./NumberedAppSupportSection.vue?vue&type=style&index=0&id=85ae0202&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85ae0202"]])

export default __exports__